var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-component',{attrs:{"isResizable":"","isReorderable":"","gridId":_vm.gridId,"itemData":_vm.itemData,"fields":_vm.fields,"onDelete":_vm.onDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }